import { render, staticRenderFns } from "./DispatchnoteDetails.vue?vue&type=template&id=143dcfe2&scoped=true"
import script from "./DispatchnoteDetails.vue?vue&type=script&lang=js"
export * from "./DispatchnoteDetails.vue?vue&type=script&lang=js"
import style0 from "./DispatchnoteDetails.vue?vue&type=style&index=0&id=143dcfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dcfe2",
  null
  
)

export default component.exports